import React from "react";

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { Root } from "./RootLayout";
/* react lazy loading */
import { lazy } from "react";

/* HomePageStart */
import HomePage from "../Interface/HomePage";

/* error page */
import Errorpage from "../NotFound/Errorpage";
import Forms, { action as newBlogPost } from "../Interface/Registration/Form";
import ProfileRoute from "./ProfileRoute";
import ProductRoute from "./ProductRoute";
import Slide from "../Slide";
// import AboutUs from "../Interface/Components/AboutUs";
/*FAQ  */
const AllFAQ = lazy(() => import("../Interface/HomePage/FAQ/AllFAQ"));

const LearnMore = lazy(() => import("../Interface/Components/LearnMore"));
const AboutUs = lazy(() => import("../Interface/Components/AboutUs"));

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route>
        <Route path="/" element={<Root />}>
          <Route index element={<HomePage />}></Route>
          {/* product */}
          <Route path="/product/*" element={<ProductRoute />} />

          {/* Profile start */}
          {/* I imported ProfileRoute from Other component,the component contains all the Child routing inside profile */}
          {/* it a new update from react router v4 */}
          <Route path="/Dashboard/*" element={<ProfileRoute />} />
          {/* Profile ends */}

          {/* FAQ */}
          <Route
            path="/AllFAQ"
            element={
              <React.Suspense fallback={<div>Loading...</div>}>
                <AllFAQ />
              </React.Suspense>
            }
          ></Route>

          <Route
            path="/LearnMore"
            element={
              <React.Suspense fallback={<div>Loading</div>}>
                <LearnMore />
              </React.Suspense>
            }
          ></Route>

          <Route
            path="/about_us"
            element={
              <React.Suspense fallback={<div>Loading</div>}>
                <AboutUs />
              </React.Suspense>
            }
          ></Route>

          <Route path="/blog" element={<Forms />} action={newBlogPost}></Route>
          <Route path="/slideTest" element={<Slide />}></Route>
        </Route>
        <Route path="*" element={<Errorpage />}></Route>
      </Route>
    </>
  )
);
